import type { ApiError } from '@/lib/api';

export function sessionErrorKey(error: ApiError): string {
  switch (error.code) {
    case 'CURRENT_SESSION':
      return 'staffSessions.errors.currentSession';
    case 'SESSION_NOT_FOUND':
      return 'staffSessions.errors.sessionNotFound';
    case 'STAFF_NOT_FOUND':
      return 'staffSessions.errors.staffNotFound';
    case 'SUPER_ADMIN_ONLY':
      return 'staffSessions.errors.superAdminOnly';
    case 'VALIDATION_FAILED':
      return 'staffSessions.errors.invalidReason';
    case 'FORBIDDEN':
      return 'staffSessions.errors.forbidden';
    default:
      return 'staffSessions.revokeFailed';
  }
}
